@if(isMobile())
{
  <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true" #tabsView [styleClass]="isMobile() ? 'mobile-view' : 'not-mobile-view'">
    <!-- <p-tabView [(activeIndex)]="activeIndex" class="custom-tabview" [scrollable]="true" #tabsView> -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div *ngFor="let tab of tabsData(); let index = index">
            <div
              [class.clickedTap]="currentClickedTapIndex === index"
              (click)="toggleTaps(index, tab.name , tab)"
              (mouseenter)="onHover = true;hoveredTap = index"
              (mouseleave)="onHover = false"
              [ngStyle]="{
                color:
                  currentClickedTapIndex === index ||
                  (onHover && hoveredTap === index)
                    ? clickedtabColor()
                    : tabColor(),
                background:
                  currentClickedTapIndex === index ||
                  (onHover && hoveredTap === index)
                    ? clickedtabBackground()
                    : tabBackground(),
                'font-family': fontFamily() ? fontFamily() : 'Poppins'
              }"
              class="tap"
              [class.ActivityLogTable]="isActivityLogTable()"
            >
              {{ tab.name }}
            </div>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
} @else {
  <div class="tabs-container">
    @if(showArrows)
    {
      <div class="prev-button" (click)="scrollTabs(-1)">
        <i class = "pi pi-angle-left"></i>
      </div>
    }
    <div class="tabs-wrapper" #tabsContainer>
      <div class="tabs" #tabs>
        <div *ngFor="let tab of tabsData(); let index = index">
          <div
            [class.clickedTap]="currentClickedTapIndex === index"
            (click)="toggleTaps(index, tab.name , tab)"
            (mouseenter)="onHover = true;hoveredTap = index"
            (mouseleave)="onHover = false"
            [ngStyle]="{
              color:
                currentClickedTapIndex === index ||
                (onHover && hoveredTap === index)
                  ? clickedtabColor()
                  : tabColor(),
              background:
                currentClickedTapIndex === index ||
                (onHover && hoveredTap === index)
                  ? clickedtabBackground()
                  : tabBackground(),
              'font-family': fontFamily() ? fontFamily() : 'Poppins'
            }"
            class="tap"
            [class.ActivityLogTable]="isActivityLogTable()"
          >
            {{ tab.name }}
          </div>
        </div>
      </div>
    </div>
    @if(showArrows)
    {
      <div class="prev-button" (click)="scrollTabs(1)">
        <i class = "pi pi-angle-right"></i>
      </div>
    }
  </div>
}